import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { api } from "../../../services/api/axios";

const BASE = "/v1/admin/personal/rate-push";

const errorMessage = (err, fallback) => {
  const message = err?.response?.data?.message;
  return Array.isArray(message) ? message.join(", ") : message || fallback;
};

export const useRatePushSettings = () =>
  useQuery({
    queryKey: ["rate-push-settings"],
    queryFn: async () => (await api.get(`${BASE}/settings`)).data.data,
    refetchOnWindowFocus: false,
  });

export const useUpdateRatePushSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (enabled) => (await api.put(`${BASE}/settings`, { enabled })).data.data,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["rate-push-settings"] });
      toast.success(data.enabled ? "Daily rate pushes are on" : "Daily rate pushes are off");
    },
    onError: (err) => toast.error(errorMessage(err, "Could not save the setting")),
  });
};

export const useRatePushPreview = () =>
  useMutation({
    mutationFn: async (kind) => (await api.post(`${BASE}/preview`, { kind })).data.data,
    onError: (err) => toast.error(errorMessage(err, "Could not build the preview")),
  });

export const useRatePushTest = () =>
  useMutation({
    mutationFn: async ({ kind, email }) => (await api.post(`${BASE}/test`, { kind, email })).data.data,
    onSuccess: (data) => {
      if (data?.error) return toast.error(data.error);
      toast.success(`Test sent to ${data.sent} device(s), ${data.failed} failed`);
    },
    onError: (err) => toast.error(errorMessage(err, "Could not send the test")),
  });
